import { render, staticRenderFns } from "./SlipPreview.vue?vue&type=template&id=57edc512&scoped=true"
import script from "./SlipPreview.vue?vue&type=script&lang=js"
export * from "./SlipPreview.vue?vue&type=script&lang=js"
import style0 from "./SlipPreview.vue?vue&type=style&index=0&id=57edc512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57edc512",
  null
  
)

export default component.exports